import { CaretUpDown } from "@phosphor-icons/react"
import { forwardRef } from "react"
import { twMerge } from "tailwind-merge"
import { Button, type ButtonProps } from "../button/Button"
import { Icon } from "../icon"
import CaretUpDownDown from "./CaretUpDownDown"
import CaretUpDownUp from "./CaretUpDownUp"
import HeaderWithSubtitle from "./HeaderWithSubtitleExperimental"
type SortableHeaderProps = Omit<ButtonProps, "children" | "title"> & {
  alignment?: "left" | "right"
  isActiveSort: boolean
  sortDirection: "asc" | "desc" | null
  subtitle?: React.ReactNode
  title: React.ReactNode
}

const SortableHeader = forwardRef<HTMLButtonElement, SortableHeaderProps>(
  (
    {
      alignment = "left",
      isActiveSort,
      onPress,
      sortDirection,
      className,
      subtitle,
      title,
      ...props
    },
    ref
  ) => {
    let sortIcon
    if (!isActiveSort) {
      sortIcon = (
        <Icon as={CaretUpDown} weight="fill" className="opacity-25 w-3 h-3" />
      )
    } else if (sortDirection === "asc") {
      sortIcon = (
        <Icon
          as={CaretUpDownUp}
          className="text-fg-default opacity-100 w-3 h-3"
        />
      )
    } else {
      sortIcon = (
        <Icon
          as={CaretUpDownDown}
          className="text-fg-default opacity-100 w-3 h-3"
        />
      )
    }

    // Wrap the icon to constrain the icon width
    sortIcon = (
      <div className="flex justify-center w-[8px]">
        <div>{sortIcon}</div>
      </div>
    )

    return (
      <Button
        ref={ref}
        variant="ghost"
        size="small"
        onPress={onPress}
        className={twMerge(
          "tt-sortable-header-button",
          // A design exploration to highlight the active sort column more
          // isActiveSort && "bg-neutral-500/5 dark:bg-neutral-300/10",
          className
        )}
        {...props}
      >
        <HeaderWithSubtitle
          title={
            <div
              className={`flex items-center gap-2 ${alignment === "right" ? "justify-end" : "justify-start"}`}
            >
              {alignment === "right" && sortIcon}
              {title}
              {alignment === "left" && sortIcon}
            </div>
          }
          subtitle={subtitle}
          alignment={alignment}
        />
      </Button>
    )
  }
)
SortableHeader.displayName = "SortableHeader"

export default SortableHeader
